export default "__VITE_ASSET__017d450d__"